import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=998731b6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Impressum.vue"
export default component.exports